import React, { useEffect } from 'react';
// @ts-ignore
import styles from './QuestionnaireOverviewList.module.scss';
import useFlatData from '../../../Base/Hooks/useFlatData';
import useQuestionnaireOverview from '../../Hooks/useQuestionnaireOverview';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import QuestionnaireOverviewListItem from './QuestionnaireOverviewItem';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';

interface Props {
	renderItem?: (item: any) => React.ReactElement;
	module?: QuestionnaireModule;
}

const WRAPPER_ID = 'questionnaireOverviewListWrapper';

const QuestionnaireOverviewList: React.FC<Props> = ({ renderItem, module }) => {
	const { getFlatQuestionnaires, data, page, setPage, getNextPage, isLoading } =
		useQuestionnaireOverview();
	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getFlatQuestionnaires,
		{
			data: data?.questionnaires?.data,
			totalPages: data?.questionnaires?.meta?.totalPages,
			page: data?.questionnaires?.meta?.page,
		},
		page,
		setPage,
		{
			module: module,
			showHidden: true,
		},
	);

	return (
		<div className={styles.wrapper}>
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={WRAPPER_ID}
					itemKey={'id'}
					renderItem={
						renderItem ??
						(item => <QuestionnaireOverviewListItem item={item} />)
					}
				/>
			</ScrollContainer>
		</div>
	);
};

export default QuestionnaireOverviewList;
